
define('text!modules/strategy/supply/pmpe/templates/active_state.html',[],function () { return '<div class="form-label">Status</div>\n<select class=\'select select-input activeState\' data-placeholder="Both">\n\t{{#statusOptions}}\n\t\t{{#getSelectOptions}}defaultStatus{{/getSelectOptions}}\n\t{{/statusOptions}}\n</select>\n';});

